import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { FaqSection } from "./home/sections/FaqSection";
import { RichText, useSiteTranslation } from "./home/i18n";
import { ContactSection } from "./help/ContactSection";

// help.faqs mirrors the English FAQs managed in Dashboard > FAQs. The FAQ API needs a
// signed-in user, so the public site keeps its own copy; update both together.
export default function HelpComponent() {
  const { t } = useSiteTranslation();

  return (
    <SiteLayout title={t("help.title")}>
      <PageHero eyebrow={t("help.eyebrow")} title={<RichText k="help.heading" />} lead={t("help.lead")} />
      <FaqSection
        items={t("help.faqs", { returnObjects: true })}
        eyebrow={t("help.faqEyebrow")}
        title={<RichText k="help.faqTitle" />}
        lead={t("help.faqLead")}
      />
      <ContactSection />
    </SiteLayout>
  );
}
